export interface SchoolTheme {
  id: string
  name: string
  shortName: string
  primaryColor: string
  secondaryColor: string
  textOnPrimary: string
  location: string
  isActive: boolean
}

export const SCHOOL_THEMES: Record<string, SchoolTheme> = {
  uh: {
    id: 'uh',
    name: 'University of Houston',
    shortName: 'UH',
    primaryColor: '#C8102E',
    secondaryColor: '#F6BE00',
    textOnPrimary: '#FFFFFF',
    location: 'Houston, TX',
    isActive: true,
  },
  utaustin: {
    id: 'utaustin',
    name: 'UT Austin',
    shortName: 'UT',
    primaryColor: '#BF5700',
    secondaryColor: '#FFFFFF',
    textOnPrimary: '#FFFFFF',
    location: 'Austin, TX',
    isActive: false,
  },
  tamu: {
    id: 'tamu',
    name: 'Texas A&M',
    shortName: 'TAMU',
    primaryColor: '#500000',
    secondaryColor: '#FFFFFF',
    textOnPrimary: '#FFFFFF',
    location: 'College Station, TX',
    isActive: false,
  },
  rice: {
    id: 'rice',
    name: 'Rice University',
    shortName: 'Rice',
    primaryColor: '#00205B',
    secondaryColor: '#C1A875',
    textOnPrimary: '#FFFFFF',
    location: 'Houston, TX',
    isActive: false,
  },
  gatech: {
    id: 'gatech',
    name: 'Georgia Tech',
    shortName: 'GT',
    primaryColor: '#003057',
    secondaryColor: '#B3A369',
    textOnPrimary: '#FFFFFF',
    location: 'Atlanta, GA',
    isActive: false,
  },
  uf: {
    id: 'uf',
    name: 'University of Florida',
    shortName: 'UF',
    primaryColor: '#0021A5',
    secondaryColor: '#FA4616',
    textOnPrimary: '#FFFFFF',
    location: 'Gainesville, FL',
    isActive: false,
  },
}

export function getSchoolTheme(schoolId: string): SchoolTheme {
  return SCHOOL_THEMES[schoolId] ?? SCHOOL_THEMES['uh']
}
